<template>
  <v-reports
    v-if="access.inv_inventory_history"
    v-bind:headers="headers"
    v-bind:update="update"
    v-bind:data="data"
    v-bind:num-pages="total"
    invHistory
    v-model="page"
    @change-pagination="changePagination"
    :data_loading="data_loading"
  >
    <template #search_text>
      <portal to="destination">
        <Loading v-if="loading" />
      </portal>
      <v-btn
        v-if="params.reason && params.reason.value == 'received'"
        icon
        @click="downloadExcelRecived"
      >
        <v-icon>mdi-download-outline</v-icon>
      </v-btn>
      <v-btn :loading="downloadexcelgroup" icon @click="downloadExcelFixed">
        <v-icon>mdi-cloud-download</v-icon>
      </v-btn>
      <v-btn icon @click="downloadExcel">
        <v-icon>mdi-download</v-icon>
      </v-btn>
      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title v-if="wait">Iltimos, kutib turing!</v-card-title>
          <v-card-title v-else>Excel yuklashga tayyor!</v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn text color="primary" @click="saveExcel" :disabled="wait">
              <export-excel
                :data="dovnExcel"
                :fields="jsonProperties"
                :name="excel_name"
                >Save Excel</export-excel
              >
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="proccesDialog" max-width="400px">
        <v-card>
          <v-list-item-action style="width: 338px; padding-left: 40px">
            <v-progress-linear
              :color="excel_dowload_proccess ? 'primary' : 'rgba(0,0,0,0.26)'"
              background-color="white"
              height="10"
              style="border: 1px solid rgba(0, 0, 0, 0.26)"
              v-bind:value="excel_dowload_proccess"
              striped
            />
            <v-list-item-action-text
              >{{ $t("download") }}
              {{ excel_dowload_proccess.toFixed() + " %" }}
            </v-list-item-action-text>
          </v-list-item-action>
        </v-card>
      </v-dialog>
      <v-slide-x-reverse-transition>
        <v-btn icon @click="searchActivate">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </v-slide-x-reverse-transition>
      <v-slide-x-reverse-transition>
        <v-text-field
          v-model="search"
          ref="search_field"
          v-if="search_text"
          autofocus
          class="mt-3 pa-0"
          append-icon="mdi-close"
          @click:append="
            {
              (search_text = false), (search = ''), update(params);
            }
          "
          @change="update(params)"
          label="Search"
        ></v-text-field>
      </v-slide-x-reverse-transition>
    </template>
  </v-reports>
  <error404 v-else></error404>
</template>
<script>
// import moment from "moment";
import Loading from "../../components/VLoading/Loading.vue";
import fileSaver from "file-saver";
import xlsx from "xlsx";
export default {
  loading: false,
  name: "ReportsSummary",
  data: () => ({
    loading: false,
    headers: [
      { text: "Date", value: "date", available: true },
      { text: "Item", value: "product_name", available: true },
      { text: "Store", value: "service_name", available: true },
      { text: "Employee", value: "employee_name", available: true },
      // { text: "Cashier", value: "cashier_name", available: true },
      { text: "Reason", value: "reason", available: true },
      { text: "Adjustment", value: "adjustment", available: true },
      { text: "Stock after", value: "stock_after", available: true },
    ],
    loader: true,
    dialog: false,
    data: [],
    page: 1,
    params: {},
    total: 0,
    data_loading: false,
    search_text: false,
    search: "",
    dovnExcel: [],
    excel_name: "History Excel Export",
    jsonProperties: {
      Id: "_id",
      Date: "date",
      Barcode: "barcode",
      Item: "product_name",
      Store: "store",
      Employee: "employee_name",
      Reason: "reason",
      Adjustment: "adjustment",
      StockAfter: "stock_after",
    },
    wait: true,
    max_total: 0,
    proccesDialog: false,
    excel_dowload_proccess: 0,
    downloadexcelgroup: false,
  }),
  methods: {
    async downloadExcelFixed() {
      this.downloadexcelgroup = true;
      const start_date = new Date(this.params.start_date);
      const end_date = new Date(this.params.end_date);
      const item_report = this.$communicator.then(
        this,
        await this.$communicator("inventory_history_report", {
          arguments: [start_date.getTime(), end_date.getTime(), 100000, 1],
          params: {
            reasons: [
              "sold",
              "returned",
              "received",
              "returned_order",
              "transferred",
              "recounted",
              "damaged",
              "lost",
              "production",
              "item edit",
            ],
            // services: this.params.service !== "" ? [this.params.service] : [],
            // employees:
            //   this.params.employee._id !== "" ? [this.params.employee._id] : [],
            // category: this.params.category,
            // reasons:
            //   this.params.reason.value !== "" ? [this.params.reason.value] : [],
            // search: this.search,
          },
        })
      );
      if (item_report.length != 0) {
        const result = await item_report.map((itrep) => ({
          Product_name: itrep.product_name,
          Product_id: itrep.product_id,
          Damaged: itrep.damaged,
          Fee: itrep.fee,
          Item_edit: itrep.item_edit,
          Loss: itrep.loss,
          Lost: itrep.lost,
          Production: itrep.production,
          Received: itrep.received,
          Recounted: itrep.recounted,
          Returned: itrep.returned,
          Returned_order: itrep.returned_order,
          Sold: itrep.sold,
          Transferred: itrep.transferred,
          Workgroup_order: itrep.workgroup_order,
        }));
        this.proccesDialog = false;
        const ws = xlsx.utils.json_to_sheet(result);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = xlsx.write(wb, { bookType: "xlsx", type: "array" });
        const excel_data = new Blob([excelBuffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
        });
        fileSaver.saveAs(excel_data, "ItemReport.xlsx");
        this.loading = false;
      }
      this.downloadexcelgroup = false;
    },
    async downloadExcelRecived() {
      this.proccesDialog = true;
      this.excel_dowload_proccess = 0;
      const start_date = new Date(this.params.start_date).getTime();
      const end_date = new Date(this.params.end_date).getTime();
      const data = [];
      const limit = 10000;
      const page_count = Math.ceil(this.max_total / limit);
      for (let page = 1; page <= page_count; page++) {
        const invhistory = this.$communicator.then(
          this,
          await this.$communicator("inventory_history", {
            arguments: [start_date, end_date, limit, page],
            params: {
              services: this.params.service !== "" ? [this.params.service] : [],
              employees:
                this.params.employee._id !== ""
                  ? [this.params.employee._id]
                  : [],
              category: this.params.category,
              reasons:
                this.params.reason.value !== ""
                  ? [this.params.reason.value]
                  : [],
              search: this.search,
            },
          })
        );
        this.excel_dowload_proccess = (page / page_count) * 100;
        // ui dagi fozini oshirib qoyamiz
        if (typeof invhistory.data == "object") data.push(...invhistory.data);
      }

      // this.dialog = true;

      const respage = Math.ceil(data.length / 10);
      this.numPages = respage ? respage : 1;
      this.page = respage ? this.page : 1;
      if (data.length != 0) {
        const result = await data.map((inv) => ({
          date: this.date_ddmmyy_hhmm(inv.date),
          purchase_id: inv.unique,
          purchace_cost: Math.round(inv.cost),
          product_name: inv.product_name,
          barcode: inv?.barcode?.reduce(function (currentSum, currentNumber) {
            return currentSum + currentNumber + ", ";
          }, ""),
          store: inv.service_name,
          employee_name: inv.employee_name,
          reason: inv.reason,
          adjustment: inv.adjustment,
          stock_after: inv.stock_after,
        }));
        this.proccesDialog = false;
        const ws = xlsx.utils.json_to_sheet(result);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = xlsx.write(wb, { bookType: "xlsx", type: "array" });
        const excel_data = new Blob([excelBuffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
        });
        fileSaver.saveAs(excel_data, "InventoryHistory.xlsx");
        this.loading = false;
      }
    },
    async downloadExcel() {
      this.proccesDialog = true;
      this.excel_dowload_proccess = 0;
      const start_date = new Date(this.params.start_date).getTime();
      const end_date = new Date(this.params.end_date).getTime();
      const data = [];
      const limit = 10000;
      const page_count = Math.ceil(this.max_total / limit);
      for (let page = 1; page <= page_count; page++) {
        const invhistory = this.$communicator.then(
          this,
          await this.$communicator("inventory_history", {
            arguments: [start_date, end_date, limit, page],
            params: {
              services: this.params.service !== "" ? [this.params.service] : [],
              employees:
                this.params.employee._id !== ""
                  ? [this.params.employee._id]
                  : [],
              category: this.params.category,
              reasons:
                this.params.reason.value !== ""
                  ? [this.params.reason.value]
                  : [],
              search: this.search,
            },
          })
        );
        this.excel_dowload_proccess = (page / page_count) * 100;
        // ui dagi fozini oshirib qoyamiz
        if (typeof invhistory.data == "object") data.push(...invhistory.data);
      }

      // this.dialog = true;

      const respage = Math.ceil(data.length / 10);
      this.numPages = respage ? respage : 1;
      this.page = respage ? this.page : 1;
      if (data.length != 0) {
        const result = await data.map((inv) => ({
          _id: inv._id,
          sku: inv.sku||"-",
          date: this.date_ddmmyy_hhmm(inv.date),
          product_name: inv.product_name,
          barcode: inv?.barcode?.reduce(function (currentSum, currentNumber) {
            return currentSum + currentNumber + ", ";
          }, ""),
          store: inv.service_name,
          employee_name: inv.employee_name,
          reason: inv.reason,
          adjustment: inv.adjustment,
          stock_after: inv.stock_after,
          supplier_name: inv.supplier_name || "-",
        }));
        this.proccesDialog = false;
        const ws = xlsx.utils.json_to_sheet(result);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = xlsx.write(wb, { bookType: "xlsx", type: "array" });
        const excel_data = new Blob([excelBuffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
        });
        fileSaver.saveAs(excel_data, "InventoryHistory.xlsx");
        this.loading = false;
      }
      this.loading = false;
    },
    saveExcel() {
      this.dialog = false;
      this.wait = true;
    },

    downloadPdf() {},
    searchActivate() {
      this.search = "";
      this.search_text = true;
    },
    changePagination(page) {
      this.page = page;
      this.update(this.params);
    },
    async update(params) {
      this.data_loading = true;
      this.params = params;
      const start_date = new Date(params.start_date);
      const end_date = new Date(params.end_date);
      const invhistory = this.$communicator.then(
        this,
        await this.$communicator("inventory_history", {
          arguments: [start_date.getTime(), end_date.getTime(), 10, this.page],
          params: {
            services: params.service !== "" ? [params.service] : [],
            employees: params.employee._id !== "" ? [params.employee._id] : [],
            category: params.category,
            reasons: params.reason.value !== "" ? [params.reason.value] : [],
            search: this.search,
          },
        })
      );
      if (invhistory) {
        this.total = invhistory.page;
        this.max_total = invhistory.total;
        for (let i = 0; i < invhistory.data.length; i++) {
          invhistory.data[i].reason = this.$t(invhistory.data[i].reason);
          const time = invhistory.data[i].date;
          invhistory.data[i].date = this.date_ddmmyy_hhmm(time);
        }
        this.data = invhistory.data;
      }
      this.data_loading = false;
    },
  },
  mounted() {
    this.headers = [
      { text: this.$t("date"), value: "date", available: true },
      { text: this.$t("item"), value: "product_name", available: true },
      { text: this.$t("barcode"), value: "barcode", available: true },
      { text: this.$t("store"), value: "service_name", available: true },
      { text: this.$t("employee"), value: "employee_name", available: true },
      // { text: this.$t("cashier"), value: "cashier_name", available: true },
      { text: this.$t("reason"), value: "reason", available: true },
      { text: this.$t("adjustment"), value: "adjustment", available: true },
      { text: this.$t("stock_after"), value: "stock_after", available: true },
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
  },
  components: {
    Loading,
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
